import { useId, useState } from 'react';
import { Minus, Plus } from 'lucide-react';

const GOLD  = '#e05590';
const DARK  = '#2a1f14';
const MUTED = 'rgba(42,31,20,0.50)';
const LINE  = 'rgba(210,60,120,0.18)';

/**
 * Wspólny akordeon pytanie/odpowiedź — wyodrębniony z `zamowienie-specjalne.tsx`
 * i `warsztaty-florystyczne.tsx`, gdzie lokalny `FaqItem` był identyczny poza
 * kosmetycznym prefiksem ARIA-id (`fq-`/`fp-` vs `w-`/`wp-`), zbędnym skoro
 * `useId()` i tak gwarantuje unikalność. Celowo NIE współdzielony z akordeonami
 * w faq.tsx, kontakt.tsx ani dostawa.tsx — to inne implementacje (inna
 * typografia, inna biblioteka animacji, dodatkowa logika podświetlania).
 */
export function FaqAccordionItem({ q, a, cmsKey }: { q: string; a: string; cmsKey?: string }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div style={{ borderBottom: `1px solid ${LINE}` }}>
      <button id={`fq-${id}`} aria-expanded={open} aria-controls={`fp-${id}`} onClick={() => setOpen(v => !v)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, padding: 'clamp(14px,1.8vw,19px) 0', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}>
        <span data-cms-text={cmsKey ? `${cmsKey}.q` : undefined} style={{ fontFamily: 'DM Sans', fontSize: 'clamp(14px,1.3vw,15px)', fontWeight: open ? 500 : 400, color: open ? DARK : 'rgba(42,31,20,0.82)', lineHeight: 1.4, flex: 1 }}>{q}</span>
        <span style={{ flexShrink: 0, width: 26, height: 26, borderRadius: '50%', border: `1px solid ${open ? GOLD : LINE}`, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'border-color 0.2s', background: open ? `${GOLD}10` : 'transparent' }}>
          {open ? <Minus size={11} color={GOLD} /> : <Plus size={11} color={MUTED} />}
        </span>
      </button>
      {open && (
        <div id={`fp-${id}`} role="region" aria-labelledby={`fq-${id}`} style={{ paddingBottom: 'clamp(14px,1.8vw,19px)', paddingRight: 42 }}>
          <p data-cms-text={cmsKey ? `${cmsKey}.a` : undefined} style={{ fontFamily: 'DM Sans', fontSize: 'clamp(13px,1.2vw,14px)', color: MUTED, lineHeight: 1.85, margin: 0 }}>{a}</p>
        </div>
      )}
    </div>
  );
}
